/**
 * Map a deployment stage name to the Datadog `env` dimension.
 *
 * Production deploys under the stage name `app` but is known to Datadog as
 * `prod`; every other stage passes through unchanged. This is the same `env`
 * Datadog uses across APM, RUM, logs, metrics and feature flags, so it's derived
 * once here and reused (cf. `buildSentryEnvironment` for the Sentry analogue).
 *
 * Accepts `string | undefined` (and passes `undefined` through) because web
 * callers source the stage from `getEnv(..., true)`, which can be unset at
 * runtime; callers coalesce the result to `'unknown'`. The return type stays
 * honest rather than asserting a `string` it cannot guarantee.
 *
 * Pure and dependency-free so it is safe to import from the browser bundle —
 * unlike `datadog-trace.ts`, which loads `dd-trace` (Node-only).
 *
 * NOTE: `cdk-stack/lib/datadog.ts` has a private copy (`toDatadogEnv`) used at
 * deploy time to set the server's `DD_ENV`. Keep the two in sync until that one
 * is migrated to import from here.
 */
export const toDatadogEnv = (stage: string | undefined): string | undefined =>
  stage === 'app' ? 'prod' : stage;
